import { render } from "./TemplateBlockItem.vue?vue&type=template&id=4802ad8f&scoped=true"
import script from "./TemplateBlockItem.vue?vue&type=script&lang=js"
export * from "./TemplateBlockItem.vue?vue&type=script&lang=js"

import "./TemplateBlockItem.vue?vue&type=style&index=0&id=4802ad8f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4802ad8f"]])

export default __exports__